export default {
  getCustomer: state => state.customer,
  getCustomers: state => state.customers,
  customerCalendarEvents: state => state.customerCalendarEvents,
  customerBalanceHistories: state => state.customerBalanceHistories,
  customerStatistics: state => state.customerStatistics,
  showArchived: state => state.showArchived,
}
